import React from 'react';
// import AcneImg from '../../images/AcneFrame.png'
import RoughImg from '../../../images/RoughFrame.png';
import PoreImg from '../../../images/PoreFrame.png';
import DarkImg from '../../../images/darkspot.png';
import BrightImg from '../../../images/brightframe.png';
import { Card } from '../Card/Card';
import { List } from '../List/List';

// TODO: move to the constant
const textMap = {
  acne: "Acne is a common skin issue that many teenagers experience. It happens when hair follicles on the skin get clogged with dead skin cells and oil, creating pimples, blackheads, and whiteheads. Hormonal changes during puberty can trigger increased oil production, leading to more acne. Genetics also play a role, so if your family members had acne, you might be more likely to have it too.\nKeeping your face clean with a gentle cleanser, avoiding touching or squeezing pimples, and using non-comedogenic products can help manage acne. Don't worry, with the right care, most people see improvements and outgrow it eventually!",
  texture:
    "Rough skin texture refers to a bumpy and uneven feeling on your skin. It happens when dead skin cells build up on the surface and aren't shed properly. This can make your skin look dull and feel rough to the touch. Environmental factors like sun exposure and pollution, as well as not moisturizing enough, can worsen roughness. To improve your skin texture, try gentle exfoliation using a scrub or a soft brush. Don't forget to moisturize daily to keep your skin hydrated.\nRegular cleansing and protecting your skin from the sun will also help you achieve a smoother complexion.",
  poreSize:
    "Large pore size refers to visible and enlarged openings on the skin's surface, often seen as tiny pits. These pores are more noticeable in some individuals due to genetic factors. Additionally, excess oil production can make pores appear larger. Teenagers may experience larger pores during puberty when hormonal changes increase oil production. Sun exposure can also damage the skin's collagen and elastin, making pores more prominent.\nRegularly cleansing the face, using non-comedogenic products, and protecting the skin from the sun can help minimize the appearance of large pores and promote overall skin health.",
  darkSpots:
    'Dark spots, also known as hyperpigmentation, are areas on your skin that appear darker than the surrounding skin. They are usually caused by an excess production of melanin, which gives your skin its color. Sun exposure, acne, skin injuries, and hormonal changes can trigger dark spots. When you pick or squeeze pimples, it may also leave dark marks.\nProtecting your skin from the sun, using sunscreen, and avoiding picking at your skin can help prevent dark spots. Treatments like topical creams with ingredients like retinoids or vitamin C may fade them over time. Be patient, as results may take weeks to show.',
  brightness:
    "Dull skin with a lack of brightness refers to a complexion that appears tired, lifeless, and lacks a natural glow. It happens when dead skin cells build up on the surface, blocking light reflection. Factors like not exfoliating regularly, dehydration, and exposure to pollution or harsh weather can contribute to dullness.\nMaintaining a healthy lifestyle with a balanced diet, staying hydrated, and getting enough sleep can help improve your skin's radiance. Also, using a gentle exfoliator once or twice a week and moisturizing daily will remove dead skin cells and keep your skin looking fresh and vibrant.",
};

const titleMap = {
  acne: 'What causes acne?',
  texture: 'What affects skin texture?',
  poreSize: 'What causes large pore size?',
  darkSpots: 'What causes dark spots?',
  brightness: 'What causes dull skin?',
};

const imageMap = {
  // acne: AcneImg,
  texture: RoughImg,
  poreSize: PoreImg,
  darkSpots: DarkImg,
  brightness: BrightImg,
};

const CausewithRightImage = ({ selectedHealth }) => {
  return (
    <Card overlay={false} title={titleMap[selectedHealth]}>
      <List
          items={[
            {
              title: '',
              image: imageMap[selectedHealth],
              description: textMap[selectedHealth],
            },
          ]}
        />
    </Card>
  );
};

export default CausewithRightImage;
